/**
 * ConfirmationModal - Reusable confirmation dialog component
 * @module components/starnexus/common/ConfirmationModal
 *
 */

import React, { useState, useCallback } from 'react';
import Modal from '@amzn/awsui-components-console/modal';
import Box from '@amzn/awsui-components-console/box';
import Button from '@amzn/awsui-components-console/button';
import SpaceBetween from '@amzn/awsui-components-console/space-between';
import { useUIStore, useConfirmationModal } from '../../../stores/starnexus/uiStore';

export const ConfirmationModal: React.FC = () => {
  const config = useConfirmationModal();
  const hideConfirmation = useUIStore((s) => s.hideConfirmation);
  const [loading, setLoading] = useState(false);

  const handleConfirm = useCallback(async () => {
    setLoading(true);
    try {
      await config.onConfirm();
      hideConfirmation();
    } catch {
      // Error handling is done by the onConfirm callback
    } finally {
      setLoading(false);
    }
  }, [config, hideConfirmation]);

  const handleCancel = useCallback(() => {
    config.onCancel?.();
    hideConfirmation();
  }, [config, hideConfirmation]);

  return (
    <Modal
      visible={config.visible}
      onDismiss={handleCancel}
      header={config.title}
      closeAriaLabel="Close modal"
      footer={
        <Box float="right">
          <SpaceBetween direction="horizontal" size="xs">
            <Button variant="link" onClick={handleCancel} disabled={loading}>
              {config.cancelLabel || 'Cancel'}
            </Button>
            <Button variant={config.variant === 'danger' ? 'primary' : 'primary'} onClick={handleConfirm} loading={loading}>
              {config.confirmLabel || 'Confirm'}
            </Button>
          </SpaceBetween>
        </Box>
      }
    >
      <Box>{config.message}</Box>
    </Modal>
  );
};

export default ConfirmationModal;
